import { motion } from 'framer-motion'
import styled from 'styled-components'

export const MotionWrapper = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  height: 2.9375em;
  width: 99%;
  margin-bottom: 0.3em;
  border-radius: 0.3125em;
  gap: 10px;
  position: relative;
  margin-top: 0;
  background-color: ${({ theme }) => theme.cor17};
  align-items: center;
`

export const CaixaTitulo = styled.div`
  height: 2.9375em;
  width: ${({ width }) => width || '5.5em'};
  border-radius: 0.3125em;
  color: #000000;
  font-size: 1em;
  font-family: RobotoRegular;
  font-weight: 700;
  line-height: 2.8125em;
  text-align: center;
  background-color: ${({ theme }) => theme.cor11};
`

export const MotionBloqueioWrapper = styled(motion.div)`
  height: 2.9375em;
  width: 205px;
  border-radius: 0.3125em;
  color: #000000;
  font-size: 1em;
  font-family: RobotoRegular;
  font-weight: 700;
  line-height: 2.8125em;
  text-align: center;
  background-color: ${({ theme }) => theme.designSystem.background.alert};
`

export const Caixa = styled.div`
  min-width: 6em;
  font-size: 1em;
  font-family: RobotoRegular;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.cor9};
`

export const CaixaFechar = styled.div`
  padding-right: 0.3125em;
  cursor: pointer;
  display: flex;
`

export const SpanBarraDados = styled.span`
  margin-left: 1em;
  margin-right: 1em;
`

export const DivisoraVertical = styled.div`
  width: 0.0625em;
  height: 2.0625em;
  margin-top: 0.4375em;
  background-color: ${({ theme }) => theme.cor7}!important;
`

export const BarraVerticalTexto = styled.span`
  font-size: 20px;
`

export const OverlayTrigger = styled.div`
  bottom: 5em;
`

export const Caixas = styled.div`
  display: flex;
  gap: 10px;
`
